import React, { useState } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Text, HStack } from '@chakra-ui/react';
import PrintQrCode from './PrintQrCode';
import { Link } from 'react-router-dom';

function ModalPrint({ isOpen, onClose, modalCashierText, url, orderId }) {
  const orderUrl = `/checkout-ok/${orderId}`;
  const qrValue = url;
  const text1 = 'Ricevuta ordine';
  const text2 = orderId;

  // Stato per tracciare se la stampa è stata lanciata
  const [hasPrinted, setHasPrinted] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // Handler per il click su stampa
  const handlePrint = () => {
    setHasPrinted(true);
  };

  // Handler per il click su chiudi
  const handleClose = () => {
    if (!hasPrinted) {
      setShowConfirm(true);
    } else {
      onClose();
    }
  };

  // Handler per confermare la chiusura
  const handleConfirmClose = () => {
    setShowConfirm(false);
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false} closeOnEsc={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Risultato Ordine</ModalHeader>
          <ModalBody>
            <Text mb={4}>{modalCashierText}</Text>
          </ModalBody>
          <ModalFooter>
            <HStack w="100%" justify="space-between">
              <Button onClick={handleClose} variant='secondary'>Chiudi</Button>
              <Button as={Link} to={orderUrl} variant='secondary'>QRCode</Button>
              <PrintQrCode qrValue={qrValue} text1={text1} text2={text2} withPreview={false} onPrint={handlePrint} />
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Modal di conferma chiusura senza stampa */}
      <Modal isOpen={showConfirm} onClose={() => setShowConfirm(false)} isCentered closeOnOverlayClick={false} closeOnEsc={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Conferma</ModalHeader>
          <ModalBody>
            <Text>Sei sicuro di chiudere senza aver lanciato la stampa?</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setShowConfirm(false)} mr={3} variant='secondary'>Annulla</Button>
            <Button onClick={handleConfirmClose}>Chiudi senza stampare</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalPrint; 